import { useEffect, useRef } from "react";
import { Outlet } from "react-router-dom";
import { useReport } from "../../utils/useReport";
import {
  useClient,
  useInstallation,
  useIsotopos,
  useSamplingReason,
} from "@services/servicesGenericsTables";
import { Loading } from "@app/components";

export default function ReportListLayout() {
  const fetched = useRef(false);

  const { fetchAll, loading } = useReport();
  const { fetchAll: fetchAllClient } = useClient();
  const { fetchAll: fetchAllInstallation } = useInstallation();
  const { fetchAll: fetchAllSamplingReason } = useSamplingReason();
  const { fetchAll: fetchAllIsotopos } = useIsotopos();

  useEffect(() => {
    if (!fetched.current) {
      fetched.current = true;
      fetchAll();
      fetchAllClient();
      fetchAllInstallation();
      fetchAllSamplingReason();
      fetchAllIsotopos();
    }
  }, []);

  return loading ? <Loading /> : <Outlet />;
}
